// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: yhV9Z2-FHhl
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import TextInput from "../../TextInput"; // plasmic-import: mVcor-OTY16/component
import SubscribeButton from "../../SubscribeButton"; // plasmic-import: ALrtfjQs8u/component
import { useScreenVariants as useScreenVariantsrrBukHdQcoc } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: rrBukHDQcoc/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicCallToActionBanner.module.css"; // plasmic-import: yhV9Z2-FHhl/css

createPlasmicElementProxy;

export const PlasmicCallToActionBanner__VariantProps = new Array();

export const PlasmicCallToActionBanner__ArgProps = new Array();

const $$ = {};

function PlasmicCallToActionBanner__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "textInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "emaildefault"
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsrrBukHdQcoc()
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__asFmc)}>
        <div className={classNames(projectcss.all, sty.freeBox___2R8Lz)}>
          <Stack__
            as={"div"}
            data-plasmic-name={"columns"}
            data-plasmic-override={overrides.columns}
            hasGap={true}
            className={classNames(projectcss.all, sty.columns)}
          >
            <div className={classNames(projectcss.all, sty.column__onZza)}>
              <div className={classNames(projectcss.all, sty.freeBox___6O9A)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ueWyq
                  )}
                >
                  {"Subscribe for retail insights"}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__vNtsE)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lHeQw
                  )}
                >
                  {
                    "Subscribe to our free newsletter on quarterly retail insights across the world. "
                  }
                </div>
              </div>
            </div>
            <div className={classNames(projectcss.all, sty.column__tzc4N)}>
              <div className={classNames(projectcss.all, sty.freeBox__dnRh7)}>
                <Stack__
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__yKyPe)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__mbyR)}
                  >
                    <TextInput
                      data-plasmic-name={"textInput"}
                      data-plasmic-override={overrides.textInput}
                      className={classNames("__wab_instance", sty.textInput)}
                      onChange={(...eventArgs) => {
                        generateStateOnChangeProp($state, [
                          "textInput",
                          "value"
                        ])((e => e.target?.value).apply(null, eventArgs));
                      }}
                      placeholder={"Enter your email"}
                      value={
                        generateStateValueProp($state, [
                          "textInput",
                          "value"
                        ]) ?? ""
                      }
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___6Gnn)}
                  >
                    <SubscribeButton
                      data-plasmic-name={"subscribeButton"}
                      data-plasmic-override={overrides.subscribeButton}
                      className={classNames(
                        "__wab_instance",
                        sty.subscribeButton
                      )}
                    />
                  </div>
                </Stack__>
              </div>
            </div>
          </Stack__>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "columns", "textInput", "subscribeButton"],
  columns: ["columns", "textInput", "subscribeButton"],
  textInput: ["textInput"],
  subscribeButton: ["subscribeButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCallToActionBanner__ArgProps,
          internalVariantPropNames: PlasmicCallToActionBanner__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCallToActionBanner__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCallToActionBanner";
  } else {
    func.displayName = `PlasmicCallToActionBanner.${nodeName}`;
  }
  return func;
}

export const PlasmicCallToActionBanner = Object.assign(
  // Top-level PlasmicCallToActionBanner renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    columns: makeNodeComponent("columns"),
    textInput: makeNodeComponent("textInput"),
    subscribeButton: makeNodeComponent("subscribeButton"),
    // Metadata about props expected for PlasmicCallToActionBanner
    internalVariantProps: PlasmicCallToActionBanner__VariantProps,
    internalArgProps: PlasmicCallToActionBanner__ArgProps
  }
);

export default PlasmicCallToActionBanner;
/* prettier-ignore-end */
